<template>
  <v-container data-aos="fade">
    <h1 class="text-center">Blog</h1>
    <v-row
      align="center"
      class="fill-height mb-5"
      justify="center"
    >
      <v-col cols="10" sm=6 md="4">
        <v-text-field
          clearable
          hide-details
          label="Search"
          prepend-icon="mdi-magnify"
          single-line
          v-model="search"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row
      align="center"
      class="fill-height"
      justify="center"
    >
      <ul class="tag-list text-center">
        <li>Seasons</li>
        <li
          v-for="season in seasons"
          :key="season.name"
        >
          <v-btn
            small
            text
            @click="filterBy(season.tags)"
          >{{season.name}}</v-btn>
        </li>
      </ul>
    </v-row>
    <v-row
      align="center"
      class="fill-height"
      justify="center"
    >
      <ul class="tag-list text-center">
        <li>Courses</li>
        <li
          v-for="course in courses"
          :key="course.name"
        >
          <v-btn
            small
            text
            @click="filterBy(course.tags)"
          >{{course.name}}</v-btn>
        </li>
      </ul>
    </v-row>
    <v-row class="mt-6">
      <v-col>
        <p>
          Be inspired for breakfast, lunch, dinner, sweet treats and even drinks all year round
          with these healthy and wholesome recipes. I am regularly adding new recipes so check
          back or sign up to the newsletter so I can let you know when there is something new!
          And if you have any questions about the recipes, please leave me a comment.
        </p>
        <p>
          The blog also features some articles I write about tips on sustainable cooking, events
          I talked at and a lot of other food related subjects which I am passionate about and
          which I think would interest you!
        </p>
      </v-col>
    </v-row>
    <v-row>
      <template v-if="recipes.length > 0 && !loading">
        <v-col
          v-for="(recipe, index) in recipes"
          :key="index"
          cols="6"
          md="3"
        >
          <v-card
            color="transparent"
            flat
            tile
            :to="`/blog/${recipe.id}`"
          >
            <v-img
              aspect-ratio="1.7778"
              class="mb-2"
              max-height="170px"
              :lazy-src="recipe.image.thumbnail"
              :src="recipe.image.url"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-card-title class="px-0 py-2">
              <span class="recipe-title">{{recipe.title}}</span>
            </v-card-title>
          </v-card>
        </v-col>
      </template>
      <template v-else-if="loading">
        <v-row
          class="fill-height ma-0"
          align="center"
          justify="center"
        >
          <v-col>
            <div class="text-center py-12">
              <v-progress-circular
                indeterminate
              ></v-progress-circular>
            </div>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-col>
          <v-card flat color="transparent">
            <p class="text-center py-12">
              No recipes found!
            </p>
          </v-card>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import {PageDocument} from '@/utils/types'
import {
  VBtn,
  VCard,
  VCardTitle,
  VCol,
  VContainer,
  VImg,
  VProgressCircular,
  VRow,
  VTextField,
} from 'vuetify/lib'

const RecipeCollection = PageDocument.Collection
    .orderBy('created', 'desc')
    .where('type', '==', 'recipe')

export default {
  components: {
    VBtn,
    VCard,
    VCardTitle,
    VCol,
    VContainer,
    VImg,
    VProgressCircular,
    VRow,
    VTextField,
  },
  computed: {
  },
  data: () => ({
    courses: [
      {name: 'All', tags: []},
      {name: 'Breakfast', tags: ['breakfast']},
      {name: 'Drinks & Smoothies', tags: ['drinks & smoothies']},
      {name: 'Soups', tags: ['soup', 'soups']},
      {name: 'Mains', tags: ['main', 'mains']},
      {name: 'Salads', tags: ['salad', 'salads']},
      {name: 'Snacks', tags: ['snack', 'snacks']},
      {name: 'Sweet Treats', tags: ['sweet treats']},
    ],
    seasons: [
      {name: 'All', tags: []},
      {name: 'Spring', tags: ['spring']},
      {name: 'Summer', tags: ['summer']},
      {name: 'Autumn', tags: ['autumn']},
      {name: 'Winter', tags: ['winter']},
    ],
    loading: true,
    search: '',
    searchTimeout: null,
    recipes: [],
  }),
  methods: {
    filterBy(tags) {
      let query = RecipeCollection.where('published', '==', true)

      if (tags.length > 0) {
        query = query
            .where('tags', 'array-contains-any', tags)
      }

      this.loading = true

      this.$bind('recipes', query)
          .then(() => this.loading = false)
    },
    onSearch(value) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }

      this.searchTimeout = setTimeout(() => {
        value = value || ''

        this.filterBy(value)
      }, 1000)
    }
  },
  mounted() {
    let searchQuery = this.$route.query.search || []

    if (searchQuery && !Array.isArray(searchQuery)) {
      searchQuery = [searchQuery]
    }

    if (searchQuery.length > 0) {
      this.onSearch(searchQuery)
    } else {
      this.filterBy([])
    }

    if (searchQuery.length > 0) {
      this.$router.replace({'query': null});
    }
  },
  watch: {
    search(value) {
      let tags = []

      if (value) {
        tags = value.split(' ')
      }

      this.onSearch(tags)
    }
  },
  destroyed() {
    clearTimeout(this.searchTimeout)
  }
}
</script>

<style lang="scss" scoped>
h1 {
  margin-top: 30px;
  font-family: 'Nanum Myeongjo', serif !important;
  font-size: 50px !important;
  color: rgba(0, 0, 0, 0.87);
}

.tag-list {
  font-size: 15px;
  list-style: none;
  margin: 5px 0;
  padding: 0;

  li:first-child {
    color: gray;
  }

  li {
    display: inline-block;
  }
}

.v-card__title {
  font-size: 16px;
  line-height: 1.5rem;
  word-break: normal;
}

.creditation {
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
}
</style>
